module.exports = __webpack_public_path__ + "img/Latvia.3e42008a.gif";